<div class="flex"
     [ngStyle]="{height: height+'px'}">
    <div class="hidden md:flex align-content-center"
         *ngIf="logoIzquierda?.show"
         [ngStyle]="{backgroundColor: logoIzquierda?.fondoColor, width: logoIzquierda?.width}">
        <div class="flex align-items-center justify-content-center m-4">
            <a [href]="logoIzquierda?.href"
               target="_blank"
               *ngIf="logoIzquierda?.href">
                <img [src]="logoIzquierda?.pathIcon"
                     width="100%"
                     [alt]="logoIzquierda?.textoIcon">
            </a>
            <img *ngIf="!logoIzquierda?.href"
                 [src]="logoIzquierda?.pathIcon"
                 [alt]="logoIzquierda?.textoIcon">
        </div>
    </div>
    <div class="flex-1 flex"
         [ngStyle]="{color: centro?.textoColor , backgroundColor: centro?.fondoColor}">
        <div class="flex-1 flex align-items-center">
            <div class="flex-1 flex flex-column">
                <h1 class="flex-1 text-center text-4xl my-1">{{centro?.texto}}</h1>
                <span *ngIf="centro?.subtitulo"
                      class="flex-1 text-center my-1 text-md">{{centro?.subtitulo}}</span>
            </div>
        </div>
    </div>
    <div class="flex align-content-center"
         *ngIf="loginActivo && usuario"
         [ngStyle]="{backgroundColor: logoDerecha?.fondoColor, width: logoDerecha?.width}">
        <div class="flex flex-column align-items-end mt-2 mr-2"
             style="color: #ffffff;">
            <span class="text-sm font-medium mb-1">{{usuario.nombre}}</span>
            <button pButton
                    type="button"
                    label="Cerrar Sesión"
                    class="p-button-warning p-button-sm"
                    (click)="logout()"></button>
        </div>
    </div>
</div>
